const PerCategoryListView = (function($h, $t) {
  const config = {
    categoryUrls: [
      // { url: "/barvy/", includeSubcategories: true, },
      // { url: "/farby/", includeSubcategories: true, },
      // { url: "/farben/", includeSubcategories: true, },
    ],
    fallbackLang: "cs",
    trans: {
      cs: {},
    },
  };

  function getBreadcrumbs() {
    return tb.dom.$map(".breadcrumbs>span", $item => {
      const $a = $item.find("a");
      return $a.length ? $a.attr("href") : location.pathname.replace(shoptet.content.regexp, "").replace(/:[^/]+\/$/, "/");
    }).toArray();
  }

  let t;
  const init = tb.dom.createModuleInitializer({
    earlyInit() {
      t = tb.helpers.getStrings(config);
      if(!$("body.type-category").length)
        return false;
    },
    earlyRender() {
      const $products = $("#products");
      if(!tb.dom.oneTime($products, "PerCategoryListView"))
        return;
      const breadcrumbs = getBreadcrumbs();
      const match = config.categoryUrls.map(url => {
        if(typeof url === "string")
          url = { url, includeSubcategories: false };
        return url;
      }).find(info => !info.includeSubcategories ? breadcrumbs[breadcrumbs.length - 1] === info.url : breadcrumbs.includes(info.url));
      if(!match)
        return false;
      $products.removeClass("products-block").addClass("products-inline tb-infinite-scroll");
    }
  });

  return { config, init };
})(tb.$h, tb.$t);

const CategoryInfiniteScroll = (function($h, $t) {
  const config = {};

  let loading = false;

  function checkScrollPosition() {
    if(!$("#products.tb-infinite-scroll").length)
      return;
    const $loadProducts = $(".load-products"), windowHeight = $(window).height(), screenBottom = $(window).scrollTop() + windowHeight;
    if($loadProducts.length && $loadProducts.offset().top < screenBottom + windowHeight * 0.1) {
      loading = true;
      $loadProducts.trigger("click");
    }
  }

  const init = tb.dom.createModuleInitializer({
    earlyInit() {
      if(!$("body.type-category").length)
        return false;
      tb.hooks.hookFn("window.showSpinner", (showSpinner, args, context) => {
        if(loading)
          return;
        return showSpinner.apply(context, args);
      });
      $(document).on("ShoptetDOMPageMoreProductsLoaded", function() {
        setTimeout(() => {
          loading = false;
        }, 500);
      });
      $(window).on("scroll", tb.common.throttle(checkScrollPosition, 250));
    },
  });

  return { config, init };
})(tb.$h, tb.$t);

const FyftBits = (function($h, $t) {
  const config = {
    landlinePrefixes: {
      "+420": ["2","3","4","5"],
    },
    fallbackLang: "cs",
    trans: {
      cs: {
        manufParameterName: "Značka",
        blogHomeUrl: "/fyft-clanky/",
        blogHomeName: "Všechny články",
        signupBenefitsTitle: "Registrací získáte následující výhody",
        signupBenefitsHtml: `<ul>
  <li><span><strong>Rychlý</strong> opakovaný <strong>nákup</strong></span></li>
  <li><span><strong>Historie</strong> všech nákupů</span></li>
  <li><span>Informace o <strong>stavu objednávek</strong></span></li>
  <li><span><strong>Nemusíte vyplňovat</strong> své údaje</span></li>
</ul>`,
        signupLoginHeader: "Máte již u nás účet? Přihlaste\u00a0se.",
        signupLoginBtnLabel: "Přihlásit se",
        loginSignupBtnLabel: "Registrovat se",
        loginUrl: "/login/",
        signupUrl: "/registrace/",
        accountEmailLabel: null,
        accountPasswordAgainLabel: null,
        loginSubmitLabel: null,
        signupSubmitLabel: "Registrovat se",
        signupNewsletterOptoutLabel: "Nepřihlašovat k FYFT newsletteru",
        customerSaveDetailsLabel: "Uložit změny",
        customerOrdersUrl: "/klient/objednavky/",
        customerHiddenUrls: ["/klient/", "/klient/dodaci-listy-klienta/"],
        customerCenterUrl: "/klient/",
        detail: "Detail",
        validatorFyftPhoneLandline: "Zadejte prosím číslo, které není pevnou linkou.",
        priorityFlags: [".flag-black-friday"],
      },
      sk: {
        manufParameterName: "Značka",
        blogHomeUrl: "/fyft-clanky/",
        blogHomeName: "Všetky články",
        signupBenefitsTitle: "Registráciou získate nasledujúce výhody",
        signupBenefitsHtml: `<ul>
  <li><span><strong>Rychlý</strong> opakovaný <strong>nákup</strong></span></li>
  <li><span><strong>História</strong> všetkých nákupov.</span></li>
  <li><span>Informácie o <strong>stave objednávok</strong></span></li>
  <li><span><strong>Nemusíte vyplňovať</strong> svoje údaje.</span></li>
</ul>`,
        signupLoginHeader: "Máte už u nás účet? Prihláste\u00a0sa.",
        signupLoginBtnLabel: "Prihlásiť sa",
        loginSignupBtnLabel: "Registrovať sa",
        loginUrl: "/login/",
        signupUrl: "/registracia/",
        accountEmailLabel: null,
        accountPasswordAgainLabel: null,
        loginSubmitLabel: null,
        signupSubmitLabel: null,
        signupNewsletterOptoutLabel: "Neprihlasovať k FYFT newsletteru",
        customerSaveDetailsLabel: "Uložiť zmeny",
        customerOrdersUrl: "/klient/objednavky/",
        customerHiddenUrls: ["/klient/", "/klient/dodacie-listy-klienta/"],
        customerCenterUrl: "/klient/",
        detail: "Detail",
        validatorFyftPhoneLandline: "Zadajte prosím číslo, ktoré nie je pevnou linkou.",
        priorityFlags: [".flag-black-friday"],
      },
      de: {
        manufParameterName: "Marke",
        brandWebsiteLabelOverride: "Website der Marke: ",
        blogHomeUrl: null,
        emptyManufacturerDetail: ["Es wurden keine Waren der Marke ", " gefunden..."],
        customerPhoneLabel: "Telefonnummer",
        signupBenefitsTitle: "Durch Ihre Registrierung erhalten Sie die folgenden Vorteile",
        signupBenefitsHtml: `<ul>
  <li><span>Schneller wiederholter Einkauf</span></li>
  <li><span>Übersicht über alle bisherigen Einkäufe</span></li>
  <li><span>Informationen zum Bestellstatus </span></li>
  <li><span>Sie müssen Ihre Daten nicht eingeben</span></li>
</ul>`,
        signupLoginHeader: "Haben Sie bereits ein Konto bei uns? Melden\u00a0Sie\u00a0sich\u00a0an.",
        signupLoginBtnLabel: "Anmelden",
        loginHeader: "Kundenanmeldung",
        loginEmailPlaceholder: "E-Mail-Adresse",
        loginSignupBtnLabel: "Registrieren",
        loginUrl: "/anmelden/",
        signupUrl: "/registration/",
        accountEmailLabel: "E-Mail-Adresse",
        accountPasswordAgainLabel: "Passwort erneut",
        loginSubmitLabel: "Anmelden",
        loginSignupLinkLabel: "Neue Kundenregistrierung",
        signupSubmitLabel: "Registrieren",
        signupNewsletterOptoutLabel: null,
        customerSaveDetailsLabel: null,
        customerOrdersUrl: "/kundencenter/meine-bestellungen/",
        customerHiddenUrls: ["/kundencenter/", "/kundencenter/lieferscheine-des-kunden/"],
        customerCenterUrl: "/kundencenter/",
        checkoutSteps: [
          "Warenkorb", "Zahlung & Versand", "Persönliche Daten",
        ],
        step1OrderInformationHeader: "Angaben zur Bestellung",
        step1DeliveryCountryLabel: "Zielland",
        step2ContactInformationHeader: "Persönliche Daten",
        fullNameLabel: "Vor- und Nachname",
        validatorInvalidPhoneNumber: "Bitte geben Sie eine gültige Telefonnummer ohne Ländervorwahl ein.",
        validatorZipCode: "Haben Sie die korrekte Postleitzahl eingegeben?",
        companyShoppingLabel: "Ich bin Geschäftskunde",
        step2DeliveryCountryNoteHtml: `Kann im <a href="/bestellung/schritt-1/"> vorherigen Schritt </a> geändert werden.`,
        step2RegInfoNote: " (Informationen zur Registrierung erhalten Sie per E-Mail)",
        detail: "Detail",
        validatorFyftPhoneLandline: "Bitte geben Sie eine Nicht-Festnetznummer ein.",
        priorityFlags: [".flag-black-friday"],
      },
    },
  };

  function respond(query, onMatch, onUnmatch) {
    const media = matchMedia(query);
    let onUnmatch2;
    function onChange() {
      if(media.matches) {
        onUnmatch2 = onMatch && onMatch();
      } else {
        onUnmatch2 && (onUnmatch2(), onUnmatch2 = null);
        onUnmatch && onUnmatch();
      }
    }
    media.addEventListener("change", onChange);
    onChange();
  }

  function fixUnderlinedLinks($el) {
    tb.dom.$each($el.find("a"), $a => {
      let $p, $top = $a;
      while(($p = $top.parent("em,strong,span")).length) {
        $top = $p;
      }
      if($top !== $a) {
        // free up $a
        $a.parent().html($a.contents());
        // wrap $top with $a
        $top.wrapAll($a);
      }
    });
  }

  function addBlogHomeToBreadcrums() {
    if(!t.blogHomeUrl)
      return;

    $h("span", { itemprop: "itemListElement", itemscope: "", itemtype: "https://schema.org/ListItem" }, [
      $h("a", { href: t.blogHomeUrl, itemprop: "item" }, [
        $h("span", { itemprop: "name" }, t.blogHomeName),
        $h("span.navigation-bullet", "/"),
      ]),
      $h("meta", { itemprop: "position" }),
    ]).insertAfter(".breadcrumbs #navigation-first");

    let pos = 1;
    tb.dom.$each(".breadcrumbs [itemprop=position]", $el => {
      $el.attr("content", pos++);
    });
  }

  const RegisterBlock = (isLogin) => $h(".register-block", [
    $h(".register-block__top", [
      $h("h4", t.signupBenefitsTitle),
      t.signupBenefitsHtml,
      isLogin ? $h("a.spec-btn", { href: t.signupUrl }, t.loginSignupBtnLabel) : null,
    ]),
    isLogin ? null : $h(".register-block__bottom", [
      $h("h4", t.signupLoginHeader),
      $h("a.spec-btn", { href: t.loginUrl }, t.signupLoginBtnLabel),
    ]),
  ]);

  function initAccountForm($form) {
    t.accountEmailLabel && $form.find("label[for=email]>span").text(t.accountEmailLabel);
    t.accountPasswordAgainLabel && $form.find("label[for=passwordAgain]>span").text(t.accountPasswordAgainLabel);

    t.customerPhoneLabel && $form.find("label[for=phone] span").text(t.customerPhoneLabel);

    const $submitBtn = $form.find("button[type=submit],input[type=submit]");
    $submitBtn.removeClass("btn-secondary").addClass("btn-primary");

    t.signupNewsletterOptoutLabel && $form.find("label[for=sendNewsletter]").text(t.signupNewsletterOptoutLabel);

    $form.addClass("ready");
  }

  function initLoginSignup(isLogin) {
    const $form = $("#register-form, #formLogin");
    $form.wrapAll("<div class='register-wrap' />");
    $(".register-wrap").append(RegisterBlock(isLogin));

    const $submitBtn = $form.find("button[type=submit],input[type=submit]");
    function setSubmitLabel(label) {
      $submitBtn.is("input") ? $submitBtn.attr("value", label) : $submitBtn.text(label);
    }
    if(isLogin) {
      const $h1 = $("#content h1");
      t.loginHeader && $h1.text(t.loginHeader);
      $h1.prependTo($form);
      t.loginSubmitLabel && setSubmitLabel(t.loginSubmitLabel);
      t.loginEmailPlaceholder && $form.find("input[name=email]").attr("placeholder", t.accountEmailPlaceholder);
      t.loginSignupLinkLabel && $form.find(".password-helper a[data-testid=signup]").text(t.loginSignupLinkLabel);
    } else {
      t.signupSubmitLabel && setSubmitLabel(t.signupSubmitLabel);
    }

    initAccountForm($form);
  }

  function initCartCheckout() {
    if(t.checkoutSteps) {
      $(".cart-header .step-1 span").text(t.checkoutSteps[0]);
      $(".cart-header .step-2 span").text(t.checkoutSteps[1]);
      $(".cart-header .step-3 span").text(t.checkoutSteps[2]);
    }
  }

  function validatePhoneInputs() {
    tb.dom.$each(".js-validate-phone", $input => {
      const value = $input.val().trim();
      const phoneCodeStr = $input.prev(".js-phone-code").val();
      let phoneCodeInfo = {};
      try {
        phoneCodeInfo = JSON.parse(phoneCodeStr) || {};
      } catch(err) {
      }
      if(!value.length || !phoneCodeInfo.phoneCode)
        return;
      const el = $input[0];
      const landlinePrefixes = config.landlinePrefixes[phoneCodeInfo.phoneCode];
      if(landlinePrefixes && landlinePrefixes.some(p => value.startsWith(p))) {
        shoptet.validator.addErrorMessage(el, "validatorFyftPhoneLandline");
        shoptet.scripts.signalCustomEvent("ShoptetValidationError", el)
      } else {
        shoptet.validator.removeErrorMessage(el, "validatorFyftPhoneLandline");
      }
    });
  }

  function sortFlags($parent) {
    const $flags = $parent.children(".flag");
    if(!$flags.length)
      return;
    $flags.sort((a, b) => {
      const $a = $(a), $b = $(b);
      const aIndex = t.priorityFlags.findIndex(sel => $a.is(sel));
      const bIndex = t.priorityFlags.findIndex(sel => $b.is(sel));
      if(aIndex === bIndex)
        return 0;
      if(aIndex === -1)
        return 1;
      if(bIndex === -1)
        return -1;
      return aIndex - bIndex;
    });
    $parent.prepend($flags);
  }

  let t;
  const init = tb.dom.createModuleInitializer({
    earlyInit() {
      t = tb.helpers.getStrings(config);

      if(t.validatorInvalidPhoneNumber)
        shoptet.messages["validatorInvalidPhoneNumber"] = t.validatorInvalidPhoneNumber;
      if(t.validatorZipCode)
        shoptet.messages["validatorZipCode"] = t.validatorZipCode;
      shoptet.messages["validatorFyftPhoneLandline"] = t.validatorFyftPhoneLandline;

      if($("body.type-detail").length) {
        // Detail

        const $manufLink = $("a[data-testid=productCardBrandName]").first();
        tb.dom.$each(".extended-description .detail-parameters tr", $tr => {
          const parameterName = tb.dom.getTextShallow($tr.find(".row-header-label")).trim();
          console.log(parameterName);
          if(parameterName === t.manufParameterName) {
            $tr.find("td").html($manufLink.clone());
          }
        });

        tb.dom.$each(".basic-description table", $table => {
          const $imageTds = tb.dom.$filter($table.find("td"), $td => $td.children().length === 1 && $td.children("img").length).addClass("fy-hero-description__image");
          if($imageTds.length)
            $table.addClass("fy-hero-description");
        });

        const $priceSave = $(".p-detail .flags.flags-extra .price-save .parameter-dependent.default-variant");
        if($priceSave.length) {
          let newHtml = $priceSave.html().trim();
          let m;
          if(m = newHtml.match(/^([\p{L}\s]+)(.*)$/u)) {
            newHtml = m[2];
            $priceSave.parent().before($h("span.parameter-dependent.default-variant", [" " + m[1]]));
          }
          $priceSave.html(newHtml);
        }

        // const $flags = $(".p-detail .flags-default").first();
        // if(!$flags.find(".flag-black-friday").length)
        //   $flags.append($h("span.flag.flag-black-friday", "Black Friday"));

        sortFlags($(".p-detail .flags-default").first());

      } else if($("body.type-category").length) {
        // Category

      } else if($("body.customer-page").length) {
        // Customer Center

        const $form = $("#register-form");
        t.customerSaveDetailsLabel && $form.find("input[type=submit]").attr("value", t.customerSaveDetailsLabel);
        initAccountForm($form);

        const $menu = $(".client-center-box ul");
        const $customerCenterLi = $menu.find("li").first();
        if($customerCenterLi.is(".active"))
          location.href = t.customerOrdersUrl;
        $menu.find(".logout").appendTo($menu);

        tb.dom.$filter($menu.find("li"), $li => t.customerHiddenUrls.includes(String($li.find("a").attr("href")).toLowerCase())).remove();

        $(".sidebar").addClass("ready");

      } else if($("#formLogin").length) {
        // Login

        initLoginSignup(true);

      } else if($("#register-form").length) {
        // Signup

        initLoginSignup(false);
      } else if($("body.type-posts-listing").length) {
        addBlogHomeToBreadcrums();

      } else if($("body.type-post").length) {
        addBlogHomeToBreadcrums();

      } else if($("body.type-manufacturer-detail").length) {

        const $perex = $("#content>.category-perex");
        if($perex.length && t.emptyManufacturerDetail) {
          $perex.html([
            t.emptyManufacturerDetail[0],
            $perex.find("strong"),
            t.emptyManufacturerDetail[1],
          ]);
        }

      } else if(getShoptetDataLayer("pageType") === "cart") {
        // Cart

        initCartCheckout();

      } else if(getShoptetDataLayer("pageType") === "billingAndShipping") {
        // Step 1

        initCartCheckout();
        t.step1OrderInformationHeader && $("h4.order-information").text(t.step1OrderInformationHeader);
        t.step1DeliveryCountryLabel && $("label[for=deliveryCountryId]").text(t.step1DeliveryCountryLabel);

      } else if(getShoptetDataLayer("pageType") === "customerDetails") {
        // Step 2

        initCartCheckout();
        t.customerPhoneLabel && $("#order-form label[for=phone] span").text(t.customerPhoneLabel);
        t.step2ContactInformationHeader && $(".co-contact-information>h4").text(t.step2ContactInformationHeader);
        t.fullNameLabel && $("label[for=billFullName] span,label[for=deliveryFullName] span").text(t.fullNameLabel);
        t.companyShoppingLabel && $("label[for=company-shopping]").text(t.companyShoppingLabel);
        t.addNoteLabel && $("label[for=add-note]").text("Anmerkung zur Bestellung hinzufügen Ihre Anmerkung");
        t.step2DeliveryCountryNoteHtml && $("label[for=deliveryCountryId]").nextAll("em").html(t.step2DeliveryCountryNoteHtml);
        t.step2RegInfoNote && $("#reg-info").text(t.step2RegInfoNote);

        let anotherShippingEmpty = Boolean(!tb.dom.$filter($("#shipping-address").find("input[type=text]"), $input => $input.val().trim() !== "").length);
        const $shippingAddressBox = $("#shippingAddressBox");
        if($shippingAddressBox.length && $shippingAddressBox.val() !== "-1") // saved address
          anotherShippingEmpty = false;
        if(anotherShippingEmpty)
          $("#another-shipping").removeAttr("data-change");
      }

      $("body").on("click", "a", function() {
        if($(this).attr("href") === t.customerCenterUrl)
          $(this).attr("href", t.customerOrdersUrl);
      });

      document.addEventListener(shoptet.validatorPhone.ajaxDoneEvent, validatePhoneInputs);
    },
    earlyRender() {
      // tb.dom.$eachOneTime(".products-block.products .p", $p => {
      //   const $flags = $p.find(".flags-default").first();
      //   if(!$flags.find(".flag-black-friday").length)
      //     $flags.append($h("span.flag.flag-black-friday", "Black Friday"));
      // }, "flagTest");

      tb.dom.$each(".p", $p => {
        if(!tb.dom.oneTime($p, "FyftBits"))
          return;

        sortFlags($p.find(".flags-default").first());

        tb.dom.$each($p.find(".flags-default .flag"), $f => {
          $f.html([
            $h(".fy-flag-bg", { style: $f.attr("style") }),
            $h(".fy-flag-text", $f.contents())
          ]);
        });

        const $prAction = $p.find(".pr-action");
        if($prAction.length && !$p.find(".p-tools>a.btn-primary").length) {
          const url = $p.find("a.name").attr("href");
          $prAction.after($h("a.btn.btn-primary", { href: url }, t.detail));
        }
      });

      tb.dom.$each(".category-title + strong", $brand => {
        if(!tb.dom.oneTime($brand, "FyftBits"))
          return;
        const $a = $brand.children("a");
        if(!$a.length)
          return;
        $a.attr("target", "_blank");
        if(t.brandWebsiteLabelOverride) {
          $brand.html([
            t.brandWebsiteLabelOverride,
            $a
          ]);
        }
      });

      tb.dom.$each(".category__secondDescription", $desc => {
        if(!tb.dom.oneTime($desc, "FyftBits"))
          return;

        fixUnderlinedLinks($desc);
      });

      tb.dom.$each("#category-header", $categoryHeader => {
        if(!tb.dom.oneTime($categoryHeader, "FyftBits"))
          return;

        const $filtersWrapper = $("#filters-wrapper");
        respond("(max-width: 1024px)", () => {
          $filtersWrapper.insertBefore($categoryHeader);
          return () => {
            $categoryHeader.insertBefore($filtersWrapper);
          };
        });
      });

      tb.dom.$each("#content iframe", $iframe => {
        if(!$iframe.parent(".video-container,.fy-feedback-form").length)
          $iframe.wrap($h(".video-container"));
      });
    },
  });

  return { config, init };
})(tb.$h, tb.$t);

(function() {
  FyftBits.init();
  PerCategoryListView.init();
  CategoryInfiniteScroll.init();
})();
